import { ScaffolderPage } from '@internal/plugin-scaffolder-fork/src/components/ScaffolderPage/ScaffolderPage';
import React from 'react';

interface customParam1 {
  selfService: boolean;
  selfServiceTitle: string;
  selfServiceCategories: string[];
}

export const SelfService = () => {
  const dataToPass: customParam1 = {
    selfService: true,
    selfServiceTitle: 'Chofer Self Service',
    selfServiceCategories: ['Cloud-Onboarding', 'Datadog-Onboarding'],
  };
  return <ScaffolderPage selfServiceData={dataToPass} />;
};
